module.exports = __webpack_public_path__ + "static/media/quote-nav-1.f0efed0a.png";